// components/LightButton.tsx
import React from 'react';
import { Button } from 'react-bootstrap';

const LightButton = ({
  children,
  show = true,
  onClick,
  disabled = false,
  size = 'sm',
  className = '',
}) => {
  if (!show) {
    return <></>;
  }

  return (
    <Button
      variant="secondary"
      disabled={disabled}
      size={size}
      onClick={onClick}
      className={className}
    >
      {children}
    </Button>
  );
};

export default LightButton;
